<template>
  <div class="customer-list-container">
    <!-- 筛选条件区域 -->
    <canvas-glass-card title="筛选条件" variant="light" :hoverable="false" class="filter-card">
      <a-form :model="queryForm" label-align="left">
        <a-grid :cols="4" :colGap="26" :rowGap="0" :collapsed="collapsed" :collapsed-rows="1">
          <a-grid-item>
            <a-form-item label="客户编码" label-col-flex="60px">
              <a-input v-model="queryForm.customerCode" placeholder="请输入客户编码" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="客户名称" label-col-flex="60px">
              <a-input v-model="queryForm.customerName" placeholder="请输入客户名称" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item>
            <a-form-item label="客户状态" label-col-flex="60px">
              <a-input v-model="queryForm.status" placeholder="请输入客户状态" class="input" allow-clear/>
            </a-form-item>
          </a-grid-item>
          <a-grid-item suffix="suffix">
            <div>
              <a-space>
                <a-button type="primary" @click="handleQuery" :loading="loading">
                  <template #icon>
                    <icon-search style="stroke: #fff"/>
                  </template>
                  搜索
                </a-button>
                <a-button type="primary" status="warning" @click="handleReset">重置</a-button>
                <!--              <a-button type="text" @click="()=>{collapsed = !collapsed}">-->
                <!--                <template #icon>-->
                <!--                  <icon-down v-if="collapsed" />-->
                <!--                  <icon-up v-else />-->
                <!--                </template>-->
                <!--                {{ collapsed ? '展开' : '收起' }}-->
                <!--              </a-button>-->
              </a-space>
            </div>
          </a-grid-item>
        </a-grid>
      </a-form>
    </canvas-glass-card>
    <a-space/>
    <!-- 客户列表表格 -->
    <canvas-glass-card variant="primary" :hoverable="false" class="table-card">
      <!-- 标题栏 -->
      <template #header>
        <a-row>
          <a-col flex="200px">
            <span class="glass-card__title">客户信息列表</span>
          </a-col>
          <a-col flex="auto"/>
          <a-col flex="80px">
<!--          <a-col flex="150px">-->
<!--            <a-button type="primary" @click="addCustomer">-->
<!--              <template #icon>-->
<!--                <icon-plus style="stroke: #fff"/>-->
<!--              </template>-->
<!--              新增-->
<!--            </a-button>-->
            <a-tooltip content="列设置">
              <a-button type="text" @click="showColumnSetting = true">
                <template #icon>
                  <icon-settings/>
                </template>
              </a-button>
            </a-tooltip>
            <a-tooltip content="刷新">
              <a-button type="text" @click="fetchTableData">
                <template #icon>
                  <icon-refresh/>
                </template>
              </a-button>
            </a-tooltip>
          </a-col>
        </a-row>
      </template>

      <!-- 客户列表数据表格 -->
      <a-table
          row-key="id"
          v-bind:columns="visibleColumns"
          :data="pagination.records"
          :pagination="false"
          :loading="loading"
          column-resizable
          stripe
          :bordered="{cell:true}"
          :scroll="{ x: 1000 }"
      >

        <template #createTime="{ record }">
          {{ formatDate(record.createTime) }}
        </template>

        <template #updateTime="{ record }">
          {{ formatDate(record.updateTime) }}
        </template>
<!--        TODO 操作列暂时不用-->
<!--        <template #action="{ record }">-->
<!--&lt;!&ndash;          <a-space>&ndash;&gt;-->
<!--            <a-button type="text" size="mini" @click="editCustomer(record)">-->
<!--              <template #icon>-->
<!--                <icon-edit/>-->
<!--              </template>-->
<!--              编辑-->
<!--            </a-button>-->
<!--            <a-popconfirm-->
<!--                content="确定要删除该客户吗？"-->
<!--                @ok="deleteCustomer(record)"-->
<!--                ok-text="确定"-->
<!--                cancel-text="取消"-->
<!--            >-->
<!--              <a-button type="text" size="mini"  status="danger">-->
<!--                <template #icon>-->
<!--                  <icon-delete/>-->
<!--                </template>-->
<!--                删除-->
<!--              </a-button>-->
<!--            </a-popconfirm>-->
<!--&lt;!&ndash;          </a-space>&ndash;&gt;-->
<!--        </template>-->
      </a-table>
      
      <!-- 分页组件 -->
      <a-pagination
          style="justify-content: end;margin: 10px;"
          v-model:current="pagination.current"
          v-model:page-size="pagination.size"
          :total="pagination.total"
          :page-size-options="[10, 20, 50, 100]"
          show-total
          show-jumper
          show-page-size
          @change="handlePageChange"
          @page-size-change="handlePageSizeChange"
      />
    </canvas-glass-card>
    
    <!-- 列设置模态框 -->
    <a-drawer
        :visible="showColumnSetting"
        title="列设置"
        @ok="handleColumnSettingOk"
        @cancel="showColumnSetting = false"
        width="300px"
        :mask-closable="false"
        :hide-cancel="true"
    >
      <div class="column-setting">
        <a-checkbox-group v-model="selectedColumns" direction="vertical">
          <a-checkbox
              v-for="column in allColumns"
              :key="column.dataIndex"
              :value="column.dataIndex"
              :disabled="column.required"
          >
            {{ column.title }}
          </a-checkbox>
        </a-checkbox-group>
      </div>
    </a-drawer>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from 'vue'
import {getCustomerPage} from '@/apis/customer-data'
import CanvasGlassCard from '@/components/CanvasGlassCard.vue'
import {
  IconSearch,
  IconDown,
  IconUp,
  IconPlus,
  IconSettings,
  IconRefresh,
  IconEdit,
  IconLock,
  IconDelete
} from '@arco-design/web-vue/es/icon'
import {Message} from "@arco-design/web-vue";
import {timestampNumber2dateString} from "@/utils/date-util";

// 条件查询表单折叠
const collapsed = ref(true)

// 条件查询表单数据
const queryForm = ref({
  customerCode: '',
  customerName: '',
  status: '',
})

// 客户列表数据
let pagination = ref({
  records: [],
  current: 1,
  size: 10,
  pages: 0,
  total: 0
})
// 加载状态
const loading = ref(false)

// 列设置相关
const showColumnSetting = ref(false)
let selectedColumns = ref([
  // 'id',
  'customerCode',
  'customerName',
  'status',
  'contactPerson',
  'contactPhone',
  'contactEmail',
  // 'companyHeaderId',
  'companyHeaderName',
  'address',
  'province',
  'city',
  'district',
  'detailedAddress',
  'longitude',
  'latitude',
  // 'level',
  // 'source',
  'level',
  'remark',
  'createTime',
  'updateTime',
  // 操作列 TODO 操作列暂时不用
  // 'action',
])

// 所有列定义
const allColumns = ref([
  // {title: 'ID', dataIndex: 'id', width: 80, required: true},
  {title: '客户编码', dataIndex: 'customerCode', width: 120, ellipsis: true, tooltip: true, fixed: 'left', required: true},
  {title: '客户名称', dataIndex: 'customerName', width: 280, ellipsis: true, tooltip: true, fixed: 'left', required: true},
  {title: '客户状态', dataIndex: 'status', width: 120, ellipsis: true, tooltip: true, slotName: 'status',},
  {title: '联系人', dataIndex: 'contactPerson', width: 130, ellipsis: true,tooltip: true},
  {title: '联系电话', dataIndex: 'contactPhone', width: 120,ellipsis: true,tooltip: true},
  {title: '联系邮箱', dataIndex: 'contactEmail', width: 180,ellipsis: true,tooltip: true},
  // {title: '公司抬头ID', dataIndex: 'companyHeaderId', width: 120, ellipsis: true, tooltip: true, slotName: 'type'},
  {title: '公司抬头', dataIndex: 'companyHeaderName', width: 120, ellipsis: true, tooltip: true, slotName: 'type'},
  {title: '客户地址', dataIndex: 'address', width: 200, ellipsis: true, tooltip: true, slotName: 'address'},
  {title: '省份', dataIndex: 'province', width: 80, ellipsis: true, tooltip: true, slotName: 'province'},
  {title: '城市', dataIndex: 'city', width: 80, ellipsis: true, tooltip: true, slotName: 'city'},
  {title: '区县', dataIndex: 'district', width: 80, ellipsis: true, tooltip: true, slotName: 'district',},
  {title: '详细地址', dataIndex: 'detailedAddress', width: 200, ellipsis: true, tooltip: true, slotName: 'detailedAddress',},
  {title: '经度', dataIndex: 'longitude', width: 100, ellipsis: true, tooltip: true, slotName: 'longitude',},
  {title: '纬度', dataIndex: 'latitude', width: 100, ellipsis: true, tooltip: true, slotName: 'latitude',},
  // {title: '客户等级', dataIndex: 'level', width: 120, ellipsis: true, tooltip: true, slotName: 'level',},
  // {title: '客户来源', dataIndex: 'source', width: 120, ellipsis: true, tooltip: true, slotName: 'source',},
  {title: '备注', dataIndex: 'remark', width: 180, ellipsis: true, tooltip: true,},
  {title: '创建时间', dataIndex: 'createTime', width: 160, ellipsis: true, tooltip: true, slotName: 'createTime',},
  {title: '更新时间', dataIndex: 'updateTime', width: 160, ellipsis: true, tooltip: true, slotName: 'updateTime',},
  // TODO 操作列暂时不用
  // {title: '操作', dataIndex: 'action', width: 180, slotName: 'action', fixed: 'right', required: true, align: 'center', cellStyle:{paddingLeft: 0,paddingRight:0}, bodyCellStyle:{paddingLeft: 0,paddingRight:0}}
])

// 可见列计算属性
const visibleColumns = computed(() => {
  return allColumns.value.filter(column => selectedColumns.value.includes(column.dataIndex))
})

// 获取表格数据
const fetchTableData = () => {
  loading.value = true;
  getCustomerPage({
    ...queryForm.value,
    current: pagination.value.current,
    size: pagination.value.size
  }).then(response => {
    // console.log(response)
    loading.value = false;
    if (response.code === 0) {
      pagination.value = response.data;
      // console.log(pagination.value)
    } else {
      Message.error(response.message);
    }
  }).catch(error => {
    Message.error(error.message)
  })
}

// 处理查询
const handleQuery = () => {
  pagination.current = 1
  fetchTableData()
}

// 重置筛选条件
const handleReset = () => {
  Object.keys(queryForm.value).forEach(key => {
    queryForm.value[key] = ''
  })
  handleQuery()
}

// 处理页码变化
const handlePageChange = (page) => {
  fetchTableData()
}

// 处理每页数量变化
const handlePageSizeChange = (size) => {
  pagination.current = 1
  fetchTableData()
}

// 列设置相关方法
const handleColumnSettingOk = () => {
  showColumnSetting.value = false
  // 这里可以保存客户的列设置到本地存储
  localStorage.setItem('customerInfoTableColumns', JSON.stringify(selectedColumns.value))
  Message.success('列设置保存成功')
}

// 格式化方法
const getStatusText = (status) => {
  const map = {'1': '正常', '2': '禁用'}
  return map[status] || '未知'
}
const getLevelText = (type) => {
  // const map = {'1': '等级1', '2': '等级2'}
  // return map[type] || '未知'
  return type || '未知'
}
const getSourceText = (type) => {
  // const map = {'1': '来源1', '2': '来源2'}
  // return map[type] || '未知'
  return type || '未知'
}
const formatDate = (dateString) => {
  // if (!dateString) return '-'
  // const date = new Date(dateString)
  // return date.toLocaleString('zh-CN')
  if (!dateString) return '—';
  // return dateString.substring(0, 16).replace('T', ' ');
  return timestampNumber2dateString(dateString)
}

// 操作方法

/**
 * 新增客户
 */
const addCustomer = () => {
  // TODO: 实现新增客户功能
  console.log('新增客户')
}

/**
 * 编辑客户
 * @param user
 */
const editCustomer = (user) => {
  // TODO: 实现编辑客户功能
  console.log('编辑客户:', user)
}

/**
 * 删除客户
 * @param user
 */
const deleteCustomer = (user) => {
  // TODO: 实现删除客户功能
  if (confirm(`确定要删除客户 ${user.customerCode} 吗？`)) {
    console.log('删除客户:', user)
  }
}

const resetPassword = (user) => {
  // TODO: 实现重置密码功能
  if (confirm(`确定要重置客户 ${user.customerCode} 的密码吗？`)) {
    console.log('重置密码:', user)
  }
}

// 组件挂载时获取数据
onMounted(() => {
  // 从本地存储加载显示列设置
  const savedColumns = localStorage.getItem('customerInfoTableColumns')
  if (savedColumns) {
    try {
      selectedColumns.value = JSON.parse(savedColumns)
      console.info('Successfully read display columns:', selectedColumns.value)
    } catch (e) {
      console.warn('Failed to parse saved columns:', e)
    }
  }

  fetchTableData()
})
</script>

<style scoped>
.input {
  border: var(--color-text-4) solid 1px;
}

.glass-card__title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #2c3e50;
  line-height: 1.4;
}
</style>